import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import ScrollToHash from "@/components/ScrollToHash";
import SiteSchema from "@/components/SiteSchema";
import HomePage from "@/pages/HomePage";
import RoomsPage from "@/pages/RoomsPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import LocalGuidePage from "@/pages/LocalGuidePage";
import AmenitiesPage from "@/pages/AmenitiesPage";
import FAQPage from "@/pages/FAQPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AccessibilityPage from "@/pages/AccessibilityPage";
import AudienceLandingPage from "@/pages/AudienceLandingPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverviewPage from "@/pages/admin/AdminOverviewPage";
import AdminRoomsPage from "@/pages/admin/AdminRoomsPage";
import AdminBlogPage from "@/pages/admin/AdminBlogPage";
import AdminFAQsPage from "@/pages/admin/AdminFAQsPage";
import AdminTestimonialsPage from "@/pages/admin/AdminTestimonialsPage";
import { AdminAttractionsPage, AdminTownsPage, AdminRedirectsPage, AdminEventsPage } from "@/pages/admin/AdminMisc";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import AdminQRCardPage from "@/pages/admin/AdminQRCardPage";
import AdminGBPPage from "@/pages/admin/AdminGBPPage";
import NotFoundPage from "@/pages/NotFoundPage";

function withLayout(node) {
  return <Layout>{node}</Layout>;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToHash />
        <SiteSchema />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontFamily: "'Manrope', sans-serif", background: "#FDFBF7", color: "#1A1A1A", border: "1px solid #E5DFD3" },
          }}
        />
        <Routes>
          <Route path="/" element={withLayout(<HomePage />)} />
          <Route path="/rooms" element={withLayout(<RoomsPage />)} />
          <Route path="/gallery" element={withLayout(<GalleryPage />)} />
          <Route path="/about" element={withLayout(<AboutPage />)} />
          <Route path="/local-guide" element={withLayout(<LocalGuidePage />)} />
          <Route path="/amenities" element={withLayout(<AmenitiesPage />)} />
          <Route path="/faq" element={withLayout(<FAQPage />)} />
          <Route path="/blog" element={withLayout(<BlogListPage />)} />
          <Route path="/blog/:slug" element={withLayout(<BlogPostPage />)} />
          <Route path="/accessibility" element={withLayout(<AccessibilityPage />)} />
          <Route path="/contact" element={withLayout(<ContactPage />)} />

          {/* Audience landing pages */}
          <Route path="/truman-lake-fishing" element={withLayout(<AudienceLandingPage audienceKey="truman-lake-fishing" />)} />
          <Route path="/katy-trail-cyclists" element={withLayout(<AudienceLandingPage audienceKey="katy-trail-cyclists" />)} />
          <Route path="/pet-friendly" element={withLayout(<AudienceLandingPage audienceKey="pet-friendly" />)} />
          <Route path="/boaters" element={withLayout(<AudienceLandingPage audienceKey="boaters" />)} />
          <Route path="/reunions" element={withLayout(<AudienceLandingPage audienceKey="reunions" />)} />
          <Route path="/extended-stay" element={withLayout(<AudienceLandingPage audienceKey="extended-stay" />)} />
          <Route path="/lake-activities" element={withLayout(<AudienceLandingPage audienceKey="lake-activities" />)} />

          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverviewPage />} />
            <Route path="rooms" element={<AdminRoomsPage />} />
            <Route path="blog" element={<AdminBlogPage />} />
            <Route path="faqs" element={<AdminFAQsPage />} />
            <Route path="attractions" element={<AdminAttractionsPage />} />
            <Route path="towns" element={<AdminTownsPage />} />
            <Route path="testimonials" element={<AdminTestimonialsPage />} />
            <Route path="redirects" element={<AdminRedirectsPage />} />
            <Route path="events" element={<AdminEventsPage />} />
            <Route path="gbp" element={<AdminGBPPage />} />
            <Route path="qr-card" element={<AdminQRCardPage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
          </Route>

          <Route path="*" element={withLayout(<NotFoundPage />)} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
